#import "../../fragments/OrderProductDetailFull.graphql"
#import "../../fragments/OrderCustomerFull.graphql"
#import "../../fragments/OrderProductOptionsFull.graphql"
#import "../../fragments/FakturoidDataFull.graphql"
#import "../../fragments/GoPayDataFull.graphql"
#import "../../fragments/OrderVoucherFull.graphql"
#import "../../fragments/AddressFull.graphql"

fragment OrderForCustomerFull on OrderForCustomer {
  appliedVoucher {
    id
    value {
      type
      absolute
      maxAbsolute
      percentageValue
    }
  }
  customer {
    ...OrderCustomerFull
  }
  orderNumber
  status
  payment {
    status
    type
    due
    amountPaid
  }
  deliveryDate
  deliveryType
  shippingAddress {
    ...AddressFull
  }
  price {
    deliveryPrice
    deliveryPriceWithoutTax
    totalPrice {
      priceLevel
      withoutTax
      withTax
    }
  }
  products {
    id
    product {
      ...OrderProductDetailFull
    }
    options {
      ...OrderProductOptionsFull
    }
    size
    quantity
    asCrossSale
  }
  vouchers {
    ...OrderVoucherFull
  }
  proformaUrl
  invoiceUrl
  fakturoidData {
    ...FakturoidDataFull
  }
  goPayData {
    ...GoPayDataFull
  }
  tenantId
  refundAmount
  paidAt
  isExpress
  createdAt
}
